// AppConfirmDialog.js
import React, {useState, useCallback, useContext, createContext, useRef} from 'react';
import {
    Dialog, DialogActions, DialogContent, DialogTitle,
    Button
} from '@mui/material';
import { AppStyle } from '../value/AppConst';

// Context to provide the confirmation dialog functions
const ConfirmDialogContext = createContext();

export const useConfirmDialog = () => {
    return useContext(ConfirmDialogContext);
};

export const AppConfirmDialogProvider = ({children}) => {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState({title:'', content:[]});
    const [option, setOption] = useState({});
    //const [callback, setCallback] = useState(null);
    const [noBackdrop, setNoBackdrop] = useState(false);
    const resolveRef = useRef(null);

    /**
     * Open the confirmation dialog
     * @param {Object} message {title: 'title', content: ['line1', 'line2', ...], option: {yesLabel: '예', noLabel: '아니오', alert: false}}
     * @param {Function} callback Callback function to be executed when the user clicks 'Yes' or 'No'
     */
    const openConfirmDialog = useCallback((message) => {
        // setMessage(message);
        const option = message.option || {};
        const title = message.title || '알림';
        const content = typeof message.content === 'string' ? [message.content] : message.content;
        setMessage({title, content});
        setOption(option);
        setNoBackdrop(false);
        setOpen(true);

        return new Promise((resolve) => {
            resolveRef.current = resolve;
        });
    }, []);

    const onClickYesOrNo = (confirm) => {
        setOpen(false);

        if (resolveRef.current) {
            resolveRef.current(confirm);
            resolveRef.current = null;
        }
    };

    return(
        <ConfirmDialogContext.Provider value={openConfirmDialog}>
            {children}
            <Dialog open={open} onClose={()=>setNoBackdrop(true)}>
                <DialogTitle style={{
                    backgroundColor: option.alert ? AppStyle.WarnRGB : AppStyle.PrimaryRGB,
                    color: '#fff'
                }}>{message.title}</DialogTitle>
                <DialogContent>
                    <ul>
                    {
                        message.content.map((line, idx) => {
                            return(
                                <li key={idx}>{line}</li>
                            );
                        })
                    }
                    {
                        noBackdrop ?
                        <li>아래 버튼 둘 중 하나를 클릭해 주세요.</li> : null
                    }
                    </ul>
                </DialogContent>
                <DialogActions>
                    {
                        option.alert ?
                        <Button onClick={()=>onClickYesOrNo(true)}>확인</Button> :
                        <>
                            <Button
                                color={AppStyle.mui.secondary}
                                variant={AppStyle.mui.contained}
                                onClick={()=>onClickYesOrNo(true)}
                            >
                                {option.yesLabel || '예'}
                            </Button>
                            <Button
                                color={AppStyle.mui.primary}
                                variant={AppStyle.mui.contained}
                                onClick={()=>onClickYesOrNo(false)}
                                style={{marginLeft: 10}}
                            >
                                {option.noLabel || '아니오'}
                            </Button>
                        </>
                    }
                </DialogActions>
            </Dialog>
        </ConfirmDialogContext.Provider>
    );
};